/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ top: NonNullable<unknown> }} Leveling_Reward_Top_AllInputs */



/**
* | output |
* | --- |
* | "Top {top} of all time" |
*
* @param {Leveling_Reward_Top_AllInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_reward_top_all = /** @type {((inputs: Leveling_Reward_Top_AllInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Reward_Top_AllInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Топ-${i?.top} за всё время`)
	return /** @type {LocalizedString} */ (`Top ${i?.top} of all time`)
});